
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-forecast/[[...beach]]",
      function () {
        return require("private-next-pages/surf-forecast/[[...beach]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-forecast/[[...beach]]"])
      });
    }
  